import { useEffect } from "react";
import Header from "../components/Header";
import CareerHero from "../components/CareerHero";
import OurValues from "../components/OurValues";
import ApplyForm from "../components/ApplyForm";
import Footer from "../components/Footer";
import { trackPageView } from "../utils/mixpanel";

function Career() {
  useEffect(() => {
    trackPageView("Careers");
  }, []);
  return (
    <div className="App">
      <Header showFullLogo={true} />
      <CareerHero />
      {/* <OurValues /> */}
      <ApplyForm />
      <Footer />
    </div>
  );
}

export default Career;
